import { OpenFeature } from '@openfeature/web-sdk';

import type { AccountState } from '../../reducers/account.reducer';
import {
  type CurrentAppContext,
  buildFeatureFlagEvaluationContext,
} from './core/featureFlagContext';
import {
  type InitializeDatadogFeatureFlagsOptions,
  initializeDatadogFeatureFlags as initializeDatadogProvider,
} from './providers/datadogProvider';
import { initializeHarnessFeatureFlags as initializeHarnessProvider } from './providers/harnessProvider';

let activeContextKey: string | undefined;
let activeContextUpdate: Promise<boolean> | undefined;

export function initializeFeatureFlags(options: InitializeDatadogFeatureFlagsOptions = {}): void {
  initializeDatadogProvider(options);
  initializeHarnessProvider();
}

export function setFeatureFlagContext(
  account: AccountState,
  currentApp: CurrentAppContext,
  isFlipdishStaff: boolean
): Promise<boolean> {
  const evaluationContext = buildFeatureFlagEvaluationContext(account, currentApp, isFlipdishStaff);
  const contextKey = JSON.stringify(evaluationContext);

  if (contextKey === activeContextKey && activeContextUpdate) {
    return activeContextUpdate;
  }

  const contextUpdate = OpenFeature.setContext(evaluationContext).then(
    () => true,
    (error: unknown) => {
      if (activeContextUpdate === contextUpdate) {
        activeContextKey = undefined;
        activeContextUpdate = undefined;
      }
      console.error('[FeatureFlags] Failed to update OpenFeature context.', error);
      return false;
    }
  );

  activeContextKey = contextKey;
  activeContextUpdate = contextUpdate;
  return contextUpdate;
}
